<template>
	<div class="reports-page">
		<Header></Header> <!-- 头部 -->
		<div class="content">
			<van-card :thumb="JOA_URL+'images/user/'+ADMIN.USER_CODE+'.jpg'" class="user-image">
				<div slot="title">
					<p>{{ADMIN.USER_NAME}}</p>
				</div>
				<div class="desc" slot="desc">
					<span>工号：{{ADMIN.USER_CODE}}</span>
					<span class="c999 right">{{this.getToday()}}</span>
				</div>
			</van-card>
			<!-- 移动定位开始 -->
			<div id="tip" style="display: none;"></div>
			<div id="tip-show" style="display: none;">
				<p id="longitude"></p><p id="latitude"></p><p id="address"></p>
				<p id="province"></p><p id="city"></p><p id="district"></p><p id="road"></p>
			</div>
			<!-- 移动定位结束 -->
			<div class="van-steps steps-items van-steps--vertical" style="padding-left:40px;">
				<div class="van-steps__items">
					<div class="van-hairline van-step van-step--vertical van-step--process up_temperature hide">
						<div class="van-step__title" style="color: rgb(7, 193, 96);">
							<div class="show">
								<p class="s-punsh"></p>
								<p class="s-tmp"></p>
								<p class="s-loc"></p>
							</div>
						</div>
						<div class="van-step__circle-container">
							<i class="van-icon van-icon-checked van-step__icon"><!----></i>
						</div>
						<div class="van-step__line"></div>
					</div>

					<div class="van-hairline van-step van-step--vertical van-step--process down_temperature_ok hide">
						<div class="van-step__title">
							<div class="show">
								<p class="s-punsh"></p>
								<p class="s-tmp"></p>
								<p class="s-loc"></p>
							</div>
						</div>
						<div class="van-step__circle-container">
							<i class="van-icon van-icon-checked van-step__icon"><!----></i>
						</div>
					</div>

					<div class="van-hairline van-step van-step--vertical down_temperature hide">
						<div class="van-step__title">
							<div class="show">
								<p class="s-punsh"><span class="title">下班打卡：</span><span class="red">无</span></p>
								<p class="s-tmp"></p>
								<p class="s-loc"></p>
							</div>
						</div>
						<div class="van-step__circle-container"><i class="van-step__circle"></i></div>
					</div>
				</div>
			</div>
			<van-grid :column-num="2" class="punch-grid">
				<van-grid-item class="punch-circl active up" @click="onConfirmPunch(0)">
					<h3><span>上班</span>打卡</h3>
					<p>{{nowtime}}</p>
				</van-grid-item>
				<van-grid-item class="punch-circl active down" @click="onConfirmPunch(1)">
					<h3><span>下班</span>打卡</h3>
					<p>{{nowtime}}</p>
				</van-grid-item>
				<van-grid-item class="punch-circl cancel" @click="onReplay">
					<h3><span>刷新</span></h3>
				</van-grid-item>
				<van-grid-item class="punch-circl sec">
					<h3>最新体温</h3>
					<p>
						<input type="text" id="temperature" name="temperature" :value="temperature" placeholder="" class="van-field__control">
					</p>
				</van-grid-item>
			</van-grid>
			<div class="user-location">
				<van-icon name="location-o" />
				<div class="location"> </div>
				<p class="right refresh" @click="onReplay"><van-icon name="replay" /></p>
			</div>
			<van-cell-group class="subform small">
				<van-cell class="required-x" title="疫苗接种:" is-link arrow-direction="down" :value="vaccination" @click="onSelect('vaccination')" />
				<van-cell v-if="isNonVacReason==true" class="required-x" title="未接种原因:" is-link arrow-direction="down" :value="nonVacReason" @click="onSelect('nonVacReason')" />
				<van-cell class="required-x" title="上班方式:" is-link arrow-direction="down" :value="workType" @click="onSelect('workType')" />
				<van-cell class="required-x" title="在隔离期:" is-link arrow-direction="down" :value="inQuarantine" @click="onSelect('inQuarantine')" />
				<van-cell class="required-x inQuarantine-time hide" title="开始时间" is-link arrow-direction="down" :value="start_date" @click="onSelectDate(1)" />
				<van-cell class="required-x inQuarantine-time hide" title="结束时间" is-link arrow-direction="down" :value="end_date" @click="onSelectDate(2)" />
				<p style="color:#ee0a24;padding-left:30.8%;">从境外返工作地后请隔离14天</p>
				<!-- <div class="inQuarantine">
                  <p>在隔离期:</p>
                  <van-cell class="formtext" arrow-direction="down" :value="inQuarantine" @click="onSelect('inQuarantine')"/>
                  <van-cell class="formtext time" arrow-direction="down" :value="start_date" @click="onSelectDate(1)" />
                  <van-cell class="formtext time" arrow-direction="down" :value="end_date" @click="onSelectDate(2)"/>
                </div>-->
				<van-cell class="required-x" title="在工作城市:" is-link arrow-direction="down" :value="arrive" @click="onSelect('arrive')" />
				<van-cell class="required-x" title="个人情况:" is-link arrow-direction="down" :value="health" @click="onSelect('health')" />
				<van-cell title="个人疾病:" class="sickness t-input required-x hide">
					<van-field
							v-model="sickness"
							name="sickness"
							placeholder=""
					/>
				</van-cell>

				<van-cell class="required-x" title="小区有确诊:" is-link arrow-direction="down" :value="isYardConfirmedCases" @click="onSelect('isYardConfirmedCases')" />
				<van-cell class="required-x" title="同住人情况:" is-link arrow-direction="down" :value="roommateSituation" @click="onSelect('roommateSituation')" />
				<van-cell title="同住人疾病:" class="roommateSickness t-input required-x hide">
					<van-field
							v-model="roommateSickness"
							name="roommateSickness"
							placeholder=""
					/>
				</van-cell>
				<div class="text-center btn-submit fixed bottom60" style="z-index:999;">
					<van-button @click="onSubmit()" type="info" size="large">提交</van-button>
				</div>
				<van-popup v-model="is_start_date_show" position="bottom" :style="{ height: '40%' }">
					<van-datetime-picker
							v-model="start_currentDate"
							type="date"
							:min-date="minDate"
							:max-date="maxDate"
							@change="OnChangeDate()"
							@confirm="OnConfirmDate()"
							@cancel="OnCancelDate()" />
				</van-popup>
				<van-popup v-model="is_end_date_show" position="bottom" :style="{ height: '40%' }">
					<van-datetime-picker
							v-model="end_currentDate"
							type="date"
							:min-date="minDate"
							:max-date="maxDate"
							@change="OnChangeDate()"
							@confirm="OnConfirmDate()"
							@cancel="OnCancelDate()" />
				</van-popup>
				<van-popup v-model="is_select_show" position="bottom" @click="onSelectPicker">
					<van-picker
							show-toolbar
							visible-item-count="1"
							:columns="select_list"
							@change="onConfirm"
							@cancel="is_select_show = false"
					/>
				</van-popup>
			</van-cell-group>

			<input id="select_type" value="" style="display: none;"/>
			<div id="closeshow">
				<van-popup
						class="close-tip"
						closeable
						v-model="is_close"
						close-icon="close"
						close-icon-position="top-right"
						:style="{ height: '300px',width: '300px'}">
					<div class="van-toast van-toast--middle">
						<i class="van-icon van-icon-success van-toast__icon"></i>
						<div class="van-toast__text">申报成功</div>
					</div>
				</van-popup>
			</div>
			<div id="closeshowpunch">
				<van-popup
						class="close-tip"
						closeable
						close-icon="close"
						close-icon-position="top-right"
						v-model="is_close_punch"
						:style="{ height: '300px',width: '300px'}">
					<div class="van-toast van-toast--middle">
						<i class="van-icon van-icon-success van-toast__icon"></i>
						<div class="van-toast__text">打卡成功</div>
					</div>
				</van-popup>
			</div>
			<!-- 右边栏固定 -->
			<!-- <div class="right-tip">
                <ul>
                    <li>
                        <img src="../../../public/images/questionnaire.png" />
                        <p>员工跨省/直辖市流动情况报备</p>
                    </li>
                </ul>
            </div> -->

			<Footer></Footer> <!-- 尾部 -->
		</div>




		<!-- 打卡弹框 -->
		<van-dialog
				class="punch"
				v-model="is_show"
				confirm-button-text="继续打卡"
				show-cancel-button
				@confirm="onPunch(1)"
		>
			<div class="punch-title" slot="title"><van-icon name="warning-o" /><p>打卡提示</p></div>
			<div class="punch-warning">
				<div>
					<p class="punch-txt">下班</p><p class="punch-time">17：00</p>
				</div>
			</div>
			<div class="punch-desc">还没到下班时间呢，亲确定要下班打卡吗？</div>
		</van-dialog>

		<input id="oa_api_ip" :value="OA_API_IP" style="display: none;"/>
		<input id="web_url" :value="WEB_URL" style="display: none;"/>
	</div>
</template>
<style lang="less">
	.van-cell__title{max-width: 22%;}
	.van-cell__value{text-align: left;}
	.last.van-cell:not(:last-child)::after{border-bottom:none;}
</style>
<script type="text/javascript">
	import axios from 'axios';
	export default {
		watch:{
			'workType': function (val) {
				var _s_loc = $(".user-location .location").html();
			    if(val && val=="居家办公"){
			       $(".punch-circl.cancel").hide();
				   var _s=$(".up_temperature .show p.s-punsh").html();
				   if($(".punch-circl.active.up").is(":hidden")==false || $(".punch-circl.active.down").is(":hidden")==false){
				   }else{
					   if(_s && _s.indexOf('"UpTime":"无"') == -1 && _s.indexOf('未打卡') == -1){ //已上班
							$(".punch-circl.active.down h3 span").html("下班");
							$(".punch-circl.active.down").show();
					   }else{
							var hour=new Date().getHours();
							if(hour>=17){ //超过17不允许打上班卡
								$(".punch-circl.active.down h3 span").html("下班");
								$(".punch-circl.active.down").show();
							}else{
								$(".punch-circl.active.up h3 span").html("上班");
								$(".punch-circl.active.up").show();
							}
					   }
				   }
			    }else{
					if(!_s_loc || (_s_loc && _s_loc.indexOf('距离还有') > 0)){
						$(".punch-circl.cancel").show();
						$(".punch-circl.active").hide();
					}
				}
			},
		},
		async created() {
			$("#loading").show();
			displayTime();//时间显示
			setTimeout(()=>{
				let hh = new Date().getHours()<10 ? "0"+new Date().getHours() : new Date().getHours();
				let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
				let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
				this.nowtime=hh+":"+mf+":"+ss;
			},1000);
			await this.getPunchConfig(); //公司打卡位置
			this.wx_location = await this.getMap();
			await this.getAddress(this.wx_location);
			//获取申报信息
			let post_data = new FormData();
			post_data.append("fUserName",JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
			axios.post(this.CoreNew.OA_API_IP+"joa-business/mobile/queryPersonInfo/",post_data,{
				headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
			}).then(function (response) {
				var $rs=JSON.parse(response.data.data);
				//console.log($rs);
				var up_html_show="";var down_html_show="";
				if(response.data.flag==true){
					if($rs.length>0 && $rs[0].IsToday=="Y"){
						this.is_reports=true; //已有申报记录
						var str_date=$rs[0].CreateDate.replace("T", " ");
						str_date=str_date.substr(11);
						up_html_show +='<span class="title">上班体温：</span><span>'+str_date.substr(0,str_date.lastIndexOf("."))+'</span><span class="red">'+$rs[0].Temperature+' °C</span><span class="green">'+$rs[0].Status+'</span>'+$rs[0].Health+'<span>('+$rs[0].WorkType+')</span>';
						$(".up_temperature .show p.s-tmp").html(up_html_show);
						$(".up_temperature").removeClass("hide");
						//值默认显示开始
						if($rs[0].StartTime!=null){
							this.start_date=$rs[0].StartTime.replace("T", " ").substr(0,10);
							this.end_date=$rs[0].EndTime.replace("T", " ").substr(0,10);
							if(this.end_date!=""){$(".inQuarantine-time").removeClass("hide");}
						}
						if($rs[($rs.length-1)].Vaccination){
							if($rs[($rs.length-1)].Vaccination=="已完成接种"){
								this.vaccination=$rs[$rs.length-1].Vaccination;
							}else{
								this.vaccination=$rs[$rs.length-1].Vaccination;
								if($rs[($rs.length-1)].Vaccination=="未接种"){
									this.nonVacReason=$rs[$rs.length-1].NonVacReason;
									this.isNonVacReason=true;
								}
							}
						}
						this.temperature=$rs[0].Temperature;
						this.workType=$rs[0].WorkType;
						this.inQuarantine=$rs[0].InQuarantine;
						this.arrive=$rs[0].IsArrive;
						this.health=$rs[0].Health;
						this.sickness=$rs[0].Sickness;
						if(this.sickness!="" && this.sickness!="null"){$(".sickness").removeClass("hide");}
						this.isYardConfirmedCases=$rs[0].IsYardConfirmedCases;
						this.roommateSituation=$rs[0].RoommateSituation;
						this.roommateSickness=$rs[0].RoommateSickness;
						if(this.roommateSickness!="" && this.roommateSickness!="null"){$(".roommateSickness").removeClass("hide");}
						//值默认显示结束
						if($rs.length>1){
							var str_date=$rs[$rs.length-1].CreateDate.replace("T", " ");
							str_date=str_date.substr(11);
							down_html_show +='<span class="title">最新体温：</span><span>'+str_date.substr(0,str_date.lastIndexOf("."))+'</span><span class="red">'+$rs[$rs.length-1].Temperature+' °C</span><span class="green">'+$rs[$rs.length-1].Status+'</span>'+$rs[$rs.length-1].Health+'<span>('+$rs[$rs.length-1].WorkType+')</span>';
							$(".up_temperature .van-step__line").css("background-color","#969799");

							$(".down_temperature_ok .show .s-tmp").html(down_html_show);
							$(".down_temperature").addClass("hide");
							$(".down_temperature_ok").removeClass("hide");
						}else{
							$(".down_temperature").removeClass("hide");
						}
					}else if($rs.length>0){
						if($rs[($rs.length-1)].Vaccination && $rs[($rs.length-1)].Vaccination=="已完成接种"){
							this.vaccination=$rs[($rs.length-1)].Vaccination;
						}
					}
				}
			}.bind(this)).catch(function (error) {
				//alert("请求--个人申报信息查询--失败"+error);
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--个人申报信息查询--失败"+error);//记录错误
				console.log("请求--个人申报信息查询--失败"+error);
			});
		},
		async mounted(){
			//重新刷新定位
			await setTimeout(()=>{
				this.onReplayRepeat();
			},60000);
			await setTimeout(()=>{
				this.onReplayRepeat();
			},300000);
			await setTimeout(()=>{
				this.onReplayRepeat();
			},600000);
			await setTimeout(()=>{
				this.onReplayRepeat();
			},1200000);

			document.addEventListener( "resume", function(e){
				this.onReplayRepeat();
			}, false );
		},
		data() {
			return {
				OA_URL:this.CoreNew.OA_URL,
				JOA_URL:this.CoreNew.JOA_URL,
				WEB_URL:this.CoreNew.WEB_URL,
				OA_API_IP:this.CoreNew.OA_API_IP,
				is_show:false,
				is_close:false,
				is_close_punch:false,
				is_reports:false,//是否有申报记录
				punchConfig_list:[],
				wx_appId:"",
				wx_timeStamp:"",
				wx_nonceStr:"",
				wx_signature:"",
				wx_location:"",
				up_html:"",
				down_html:"",
				ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
				//is_date_show: false,
				is_date_type:1,
				nowtime:"",
				temperature:"",
				start_date:"",end_date:"",
				minDate: new Date(2020, 0, 1),
				maxDate: new Date(2026, 12, 1),
				//currentDate: new Date(2020, 2, 26),
				start_currentDate: new Date(),
				end_currentDate: new Date(),
				is_start_date_show: false,
				is_end_date_show: false,
				is_select_show:false,
				select_list: ['请选择','Y','N'],
				start_date:'请选择',
				end_date:'请选择',
				workType:'到岗上班',
				inQuarantine:'N',
				arrive:'Y',
				health:'身体正常',
				sickness:"",
				roommateSickness:"",
				isYardConfirmedCases:'无',
				roommateSituation:'身体正常',

				vaccination:"请选择",
				nonVacReason:"请选择",
				isNonVacReason:false,
			};
		},
		methods: {
			TodayTime: function () {
				let hh = new Date().getHours()<10 ? "0"+new Date().getHours() : new Date().getHours();
				let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
				let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
			},
			//新oa
			async getMap() {
				return new Promise((resolve, reject) => {
					let redirect_url=encodeURIComponent(window.location.href); //当前url
					axios.get(this.CoreNew.NEW_OA_API_URL+"api/wechatwork/basic/common/signature?url="+redirect_url, {
						headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
					}).then(function (response) {
						console.log(response)
						var rs=response.data;
						if(rs.code==200){
							this.wx_appId=this.CoreNew.QWXAPPID;
							this.wx_timeStamp=rs.data.timestamp;
							this.wx_nonceStr=rs.data.nonceStr;
							this.wx_signature=rs.data.signature;
							wx.config({
								debug: false,
								appId: this.wx_appId,
								timestamp: this.wx_timeStamp,
								nonceStr: this.wx_nonceStr,
								signature: this.wx_signature,
								jsApiList: [
									'getLocation'
								]
							});
							wx.ready(function(){
								wx.getLocation({
									type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
									success: function (res) {
										var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
										var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
										//var speed = res.speed; // 速度，以米/每秒计
										//var accuracy = res.accuracy; // 位置精度
										resolve(longitude+","+latitude);
									}
								});
							});
							wx.error(function(res){
								//reject(false);
								console.log("error"+JSON.stringify(res));
								// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
							});
						}else{
							this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求OA--定位授权--失败"+error);//记录错误
							console.log("请求OA--定位授权--失败"+error);
						}
					}.bind(this)).catch(function (error) {
						reject(false);
						this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求微信--定位--失败"+error);//记录错误
						console.log("请求微信--定位--失败"+error);
					});
				});
			},

			async getMap2() {
				return new Promise((resolve, reject) => {
					axios.get("https://mb.cecport.com?sign=1", {
					}).then(function (response) {
						var data = response.data.split(',');
						this.wx_appId=data[0];this.wx_timeStamp=data[1];
						this.wx_nonceStr=data[2];this.wx_signature=data[3];
						wx.config({
							debug: false,
							appId: this.wx_appId,
							timestamp: this.wx_timeStamp,
							nonceStr: this.wx_nonceStr,
							signature: this.wx_signature,
							jsApiList: [
								'getLocation'
							]
						});
						wx.ready(function(){
							wx.getLocation({
								type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
								success: function (res) {
									var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
									var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
									//var speed = res.speed; // 速度，以米/每秒计
									//var accuracy = res.accuracy; // 位置精度
									resolve(longitude+","+latitude);
								}
							});
						});
						wx.error(function(res){
							//reject(false);
							//alert("error"+JSON.stringify(res))
							console.log("error"+JSON.stringify(res));
							// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
						});
					}.bind(this)).catch(function (error) {
						reject(false);
						//alert("请求微信--定位--失败"+error);
						this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求微信--定位--失败"+error);//记录错误
						console.log("请求微信--定位--失败"+error);
					});
				});
			},
			async getAddress(user_location) {
				var is_gmap=false;
				is_gmap=await this.getAddress_map(user_location);
				if(is_gmap==true){
					var punchConfig_list=JSON.parse(localStorage.getItem('MAP_punchConfig_list'));
					var data=JSON.parse(localStorage.getItem('MAP_data'));

					var is_location=false;
					for (var i = 0; i < punchConfig_list.length; i++) {
						is_location=await this.makePunch(data,punchConfig_list[i].BASELONGITUDE,punchConfig_list[i].BASELATITUDE,punchConfig_list[i].BASEACCURACY,i,punchConfig_list.length);
						console.log("员工打卡地址"+i);
						if(is_location==true){
							break;
						}
					}
					//定位成功，震动效果
					if (window.navigator.vibrate){
						console.log("你的浏览器支持调用手机震动");
						window.navigator.vibrate(300);
					}else{
						console.log("你的浏览器不支持调用手机震动");
					}
					$("#loading").hide();
				}else{
					this.$dialog.alert({
						message: '定位异常，请稍后再试',
						showConfirmButton:true
					});
					$("#loading").hide();
				}
			},
			async getAddress_map(user_location) {
				return new Promise((resolve, reject) => {
					var data = user_location.split(',');
					var lng=data[0];
					var lat=data[1];
					/*var map = new AMap.Map('container', {
                       center:[lng,lat],
                       zoom:12,
                       resizeEnable: true
                    });
                    var geocoder = new AMap.Geocoder({
                        city: "010", //城市设为北京，默认：“全国”
                    });
                    var lnglat  = lng + "," + lat;
                    //var lnglat  = "114.000222,22.58936";
                    */
					var geocoder, map , lnglat = null;
					//lnglat = new qq.maps.LatLng(22.541418,114.047871);
					lnglat = new qq.maps.LatLng(lat,lng);
					map = new qq.maps.Map('container', {
						center: lnglat,
						zoom: 12,
					});

					//地址和经纬度之间进行转换服务
					geocoder = new qq.maps.Geocoder();
					//设置服务请求成功的回调函数
					geocoder.setComplete(function(result) {
						map.setCenter(result.detail.location);
					});
					//若服务请求失败，则运行以下函数
					geocoder.setError(function() {
						alert("获取定位错误");
						resolve(false);
					});
					var tmp_punchConfig_list=this.punchConfig_list;
					localStorage.setItem('MAP_punchConfig_list', JSON.stringify(tmp_punchConfig_list));
					//var WX_VUE=this;
					geocoder = new qq.maps.Geocoder({
						complete : function(result){
							console.log('获取定位成功');
							console.log(result);
							console.log(result.detail.address);
							var data=result.detail;
							data["longitude"]=lng;
							data["latitude"]=lat;
							//data["longitude"]="114.000222";
							//data["latitude"]="22.58936";
							localStorage.setItem('MAP_data', JSON.stringify(data));
							resolve(true);
						}
					});
					geocoder.getAddress(lnglat);
					/*geocoder.getAddress(lnglat, function(status, result) {
                        if (status === 'complete'&&result.regeocode) {
                            //var address = result.regeocode.formattedAddress;
                            var data=result.regeocode;
                            data["longitude"]=lng;
                            data["latitude"]=lat;
                            //data["longitude"]="114.000222";
                            //data["latitude"]="22.58936";
                            localStorage.setItem('MAP_data', JSON.stringify(data));
                            resolve(true);
                        }else{
                            console.log('高德地图获取地址失败');
                            resolve(false);
                        }
                    });*/
				});
			},

			async makePunch(data,company_Lng,company_Lat,company_Distance,locations_active,locations_length) {
				return new Promise((resolve, reject) => {
					var myplace = ''; //我的位置
					var mycity = ''; //我所在的城市
					//company_Lng="114.000222";var company_Lat="22.58936";var company_Distance=150; //塘朗
					//company_Lng="114.047871";var company_Lat="22.541418";var company_Distance=120; //信息
					//114.00009,22.589629
					//myplace = data.formattedAddress; //我的位置
					//mycity = data.addressComponent.city; //我所在的城市
					//myplace = data.address; //我的位置
					myplace =  data.addressComponents.province+data.addressComponents.city+data.addressComponents.district+data.addressComponents.town+data.addressComponents.street+data.addressComponents.streetNumber;//我的位置
					mycity = data.addressComponents.city; //我所在的城市
					if(mycity==""){ //避免获取不到城市
						if(myplace!=""){
							mycity=myplace.substr(0,3);
						}
					}
					localStorage.setItem('LS_ADRESS', JSON.stringify(myplace));
					localStorage.setItem('LS_CITY', JSON.stringify(mycity));
					//console.log(data);
					//提交地址信息
					var str = ['定位成功'];
					str.push('经度：' + data.longitude);
					str.push('纬度：' + data.latitude);
					//str.push('地址：' + data.formattedAddress);
					str.push('地址：' + myplace);
					document.getElementById('tip').innerHTML = str.join('<br>');
					$("#tip-show #longitude").html(data.longitude);
					$("#tip-show #latitude").html(data.latitude);
					//$("#tip-show #address").html(data.formattedAddress);
					$("#tip-show #address").html(myplace);
					$("#tip-show #province").html(data.addressComponents.province);
					$("#tip-show #city").html(data.addressComponents.city);
					$("#tip-show #district").html(data.addressComponents.district);
					$("#tip-show #road").html(data.addressComponents.street+data.addressComponents.streetNumber);
					//$("#tip-show #province").html(data.addressComponent.province);
					//$("#tip-show #city").html(data.addressComponent.city);
					//$("#tip-show #district").html(data.addressComponent.district);
					//$("#tip-show #road").html(data.addressComponent.street+data.addressComponent.streetNumber);
					// 经纬度计算
					var start = new LngLat(data.longitude, data.latitude);
					var end = new LngLat(company_Lng,company_Lat);//公司地址
					var distance=calculateLineDistance(start, end);
					//$(".user-location .location").html(data.formattedAddress);
					$(".user-location .location").html(myplace);
					/*获取是否有打卡记录*/
					$.ajax({
						type:"POST",
						url:$("#oa_api_ip").val()+"joa-business/mobile/queryPunch",
						dataType:"json",
						async:false,
						headers:{'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))},
						data:{userName:JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME'))},
						success:function(response){
							var $rs=response.data;
							if(response.flag==true){
								var $res=JSON.parse(response.data);
								if(response.data.indexOf('"UpTime":"无"') == -1){
									var punch_up_html='<span class="title">上班时间：</span><span class="red">'+JStoTimeHFM($res.UpTime)+'</span>';
									$(".up_temperature .show p.s-punsh").html(punch_up_html);
									$(".up_temperature .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>'+$res.UpAddress+'</span>');
								}else{
									var punch_up_html='<span class="title">上班时间：</span><span class="red">未打卡</span>';
									$(".up_temperature .show p.s-punsh").html(punch_up_html);
									$(".up_temperature .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>无</span>');
								}
								if(response.data.indexOf('"DownTime":"无"') == -1){
									//$("#down_show .van-card__desc").html(JStoTimeHFM($res.DownTime));
									var punch_down_html='<span class="title">下班时间：</span><span class="red">'+JStoTimeHFM($res.DownTime)+'</span>';
									$(".down_temperature_ok .show p.s-punsh").html(punch_down_html);
									$(".down_temperature .show p.s-punsh").html(punch_down_html);
									$(".down_temperature_ok .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>'+$res.DownAddress+'</span>');
									$(".down_temperature .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>'+$res.DownAddress+'</span>');
								}else{
									var punch_down_html='<span class="title">下班时间：</span><span class="red">未打卡</span>';
									$(".down_temperature_ok .show p.s-punsh").html(punch_down_html);
									$(".down_temperature .show p.s-punsh").html(punch_down_html);
									$(".down_temperature_ok .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>无</span>');
									$(".down_temperature .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>无</span>');
								}
								if(distance > company_Distance){
									//$(".user-location .location").html(data.formattedAddress+"(距离还有"+parseInt(distance)+"米)");
									$(".user-location .location").html(myplace+"(距离还有"+parseInt(distance)+"米)");
									$(".punch-circl.cancel").show();
									$(".punch-circl.active").hide();
									if((locations_active+1)==locations_length){
										//return true;
										resolve(true);
									}else{
										//return false;
										resolve(false);
									}
								}else{
									$(".punch-circl.cancel").hide();
									if(response.data.indexOf('"UpTime":"无"') == -1){ //已上班
										$(".punch-circl.active.down h3 span").html("下班");
										$(".punch-circl.active.down").show();
									}else{
										var hour=new Date().getHours();
										if(hour>=17){ //超过17不允许打上班卡
											$(".punch-circl.active.down h3 span").html("下班");
											$(".punch-circl.active.down").show();
										}else{
											$(".punch-circl.active.up h3 span").html("上班");
											$(".punch-circl.active.up").show();
										}
									}
									resolve(true);
								}
							}
						},
						error:function(){
							reject(false);
							//alert("请求--打卡信息--失败"+error);
							console.log("请求--打卡信息--失败"+error);
						}
					});
				});
			},
			async getPunchConfig() {
				let post_data = new FormData();
				post_data.append("userName",JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
				return new Promise((resolve, reject) => {
					axios.post(this.CoreNew.OA_API_IP+"joa-business/mobile/queryPunchConfig",post_data,{
						headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
					}).then(function (response) {
						if(response.data.flag==true){
							this.punchConfig_list=response.data.data;
							resolve(true);
							//alert(this.punchConfig_list[0].BASELONGITUDE)
						}else{
							resolve(false);
						}
					}.bind(this)).catch(function (error) {
						reject(false);
						//alert("请求--获取打卡工作位置信息--失败"+error);
						this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--获取打卡工作位置信息--失败"+error);//记录错误
						console.log("请求--获取打卡工作位置信息--失败"+error);
					});
				});
			},
			clostTop: function () {
				var time = 3;
				var timer = setInterval(function() {
					time--;
					if(time == 0) {
						this.is_close=false;
						clearInterval(timer);//清楚定时
					}
				}, 1000);
			},
			async onReplayRepeat() {
				this.wx_location = await this.getMap();//获取定位
				this.getAddress(this.wx_location);
			},
			async onReplay() {
				$("#loading").show();
				this.wx_location = await this.getMap();//获取定位
				this.getAddress(this.wx_location);
			},
			checkReports:function(){
				//检查是否有申报记录
				let r_post_data = new FormData();
				r_post_data.append("fUserName",JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
				return new Promise((resolve, reject) => {
					axios.post(this.CoreNew.OA_API_IP+"joa-business/mobile/queryPersonInfo/",r_post_data,{
						headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
					}).then(function (response) {
						var $rs=JSON.parse(response.data.data);
						if(response.data.flag==true){
							if($rs.length>0){
								resolve(true);
							}else{
								resolve(false);
							}
						}else{
							resolve(false);
						}
					}.bind(this)).catch(function (error) {
						reject(false);
						//alert("请求--个人申报记录--失败"+error);
						//this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--个人申报记录--失败"+error);//记录错误
						//console.log("请求--个人申报记录--失败"+error);
					});
				});
			},
			async onConfirmPunch (type) {
				//this.is_reports = await this.checkReports();
				if(this.is_reports==true){
					var hour=new Date().getHours();
					if(type==1 && (hour<17)){
						this.is_show=true;
						//请先打上班卡
						/*if($(".punch-circl.active.up").html().indexOf("已签")>0){
                            this.is_show=true;
                        }else{
                            this.$toast.setDefaultOptions({ duration: 3000});
                            this.$toast("请先打上班卡");
                        }*/
					}else{
						this.onPunch(type);
					}
				}else{
					this.$dialog.alert({
						title: '请先填写个人信息申报'
					}).then(() => {})
				}
			},
			onPunch:function(punchtype){
				//$("#closeshowpunch").show();
				var HFMtime=this.getTimeHFM();//操作时间
				this.is_show=false;$("#loading").show();
				//触发打卡
				let post_data = new FormData();
				post_data.append("workPunchTypeDb",punchtype); //0上班，1下班
				post_data.append("sourceType",1);//PC:0,微信:1,钉钉:2
				post_data.append("userName",JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
				post_data.append("uuid",JSON.parse(localStorage.getItem('LS_QWX_DEVICEID')));//设备号
				post_data.append("macIp","");
				post_data.append("longitude",$("#tip-show #longitude").html());
				post_data.append("latitude",$("#tip-show #latitude").html());
				post_data.append("accuracy",25);
				post_data.append("address",$("#tip-show #address").html());
				post_data.append("province",$("#tip-show #province").html());
				post_data.append("city",$("#tip-show #city").html());
				post_data.append("district",$("#tip-show #district").html());
				post_data.append("road",$("#tip-show #road").html());
				post_data.append("netType","");
				post_data.append("operatorType","");
				axios.post(this.CoreNew.OA_API_IP+"joa-business/mobile/savePunch",post_data,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
					var $rs=response.data;
					//if($rs.flag==true && ($rs.data.indexOf('"UpTime":"无"') == -1 || $rs.data.indexOf('"DownTime":"无"') == -1)){
					if($rs.flag==true){
						//var $res=JSON.parse($rs.data.substring(1,$rs.data.length-1));
						//var $res=$rs.data.substring(1,$rs.data.length-1);
						$("#loading").hide();
						this.is_close_punch=true;
						//this.$toast.success('打卡成功');
						if(punchtype==0){
							$(".punch-circl.active.up").hide();
							$(".punch-circl.active.down").show();
							var punch_up_html='<p><span class="title">上班时间：</span><span class="red">'+HFMtime+'</span></p>';
							$(".up_temperature .show p.s-punsh").html(punch_up_html);
							$(".up_temperature .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>'+$(".user-location .location").html()+'</span>');
						}else{
							$(".punch-circl.active.up").hide();
							$(".punch-circl.active.down").show();
							var punch_down_html='<p><span class="title">下班时间：</span><span class="red">'+HFMtime+'</span></p>';
							$(".down_temperature_ok .show p.s-punsh").html(punch_down_html);
							$(".down_temperature .show p.s-punsh").html(punch_down_html);
							$(".down_temperature_ok .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>'+$(".user-location .location").html()+'</span>');
							$(".down_temperature .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>'+$(".user-location .location").html()+'</span>');
						}
						setTimeout(()=>{
							this.is_close_punch=false;
						},3000);
					}else{
						$("#loading").hide();
						this.is_close_punch=false;
					}
				}.bind(this)).catch(function (error) {
					this.is_close_punch=false;
					//alert("请求--保存打卡--失败"+error);
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--保存打卡--失败"+error);//记录错误
					console.log("请求--保存打卡--失败"+error);
				});
			},
			onConfirm: function (picker, value, index) {
				if($("#select_type").val()=="vaccination"){ //疫苗接种情况
					this.vaccination=value;
					if(this.vaccination=="未接种"){
						this.isNonVacReason=true;
					}else{
						this.isNonVacReason=false;
					}
				}else if($("#select_type").val()=="nonVacReason"){ //未接种原因
					this.nonVacReason=value;
				}else if($("#select_type").val()=="workType"){ //到岗方式
					this.workType=value;
				}else if($("#select_type").val()=="inQuarantine"){ //在隔离期
					this.inQuarantine=value;
					if(value=="Y"){
						$(".inQuarantine-time").removeClass("hide");
					}else{
						$(".inQuarantine-time").addClass("hide");
					}
				}else if($("#select_type").val()=="arrive"){ //在工作城市
					this.arrive=value;
				}else if($("#select_type").val()=="health"){ //个人情况
					this.health=value;
					if(value=="其他不适疾病"){
						$(".sickness").removeClass("hide");
					}else{
						$(".sickness").addClass("hide");
					}
				}else if($("#select_type").val()=="isYardConfirmedCases"){ //小区有确诊
					this.isYardConfirmedCases=value;
				}else if($("#select_type").val()=="roommateSituation"){ //同住人情况
					this.roommateSituation=value;
					if(value=="其他不适疾病"){
						$(".roommateSickness").removeClass("hide");
					}else{
						$(".roommateSickness").addClass("hide");
					}
				}
				this.is_select_show = false;
			},
			onSelect: function (type) {
				this.temperature=$("#temperature").val();
				if(type=="vaccination"){ //疫苗接种情况
					this.select_list=['请选择','已完成接种','已接种第一针','未接种'];
				}else if(type=="nonVacReason"){ //未接种原因
					this.select_list=['请选择','身体原因','疫苗预约中'];
				}else if(type=="workType"){ //到岗方式
					this.select_list=['请选择','到岗上班','出差办公','外出办公','居家办公','休假中'];
				}else if(type=="inQuarantine"){ //在隔离期
					this.select_list=['请选择','N','Y'];
				}else if(type=="arrive"){ //在工作城市
					this.select_list=['请选择','Y','N'];
				}else if(type=="health"){ //个人情况
					this.select_list=['请选择','身体正常','疑似新型肺炎','确诊新型肺炎','其他不适疾病'];
				}else if(type=="isYardConfirmedCases"){ //小区有确诊
					this.select_list=['请选择','无','<14天有','>14天有'];
				}else if(type=="roommateSituation"){ //同住人情况
					this.select_list=['请选择','身体正常','疑似新型肺炎','确诊新型肺炎','其他不适疾病'];
				}else{
					this.select_list=['请选择','Y','N'];
				}
				$("#select_type").val(type);
				this.is_select_show = true;
			},
			onSelectPicker: function () {
				this.is_select_show = false;
			},
			onSelectDate: function (i) {
				this.temperature=$("#temperature").val();
				if(i==2){
					this.is_date_type=2;this.is_start_date_show = false;
					this.is_end_date_show = true;
				}else{
					this.is_date_type=1;this.is_end_date_show = false;
					this.is_start_date_show = true;
				}
			},
			OnChangeDate: function () {
				//this.changeDate = this.currentDate ;
			},
			OnConfirmDate: function () {
				if(this.is_date_type==2){
					this.end_date = this.GetTimeFormat(this.end_currentDate);
				}else{
					this.start_date = this.GetTimeFormat(this.start_currentDate);
				}
				this.is_start_date_show = false;this.is_end_date_show = false;
			},
			OnCancelDate: function () {
				this.is_start_date_show = false;this.is_end_date_show = false;
			},
			getTimeHFM:function(){
				let hh = new Date().getHours()<10 ? "0"+new Date().getHours() : new Date().getHours();
				let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
				let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
				return hh+":"+mf+":"+ss;
			},
			GetTimeFormat: function (time) {// 时间格式化 2019-09-08
				let y = time.getFullYear();
				let MM = time.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = time.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = time.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = time.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				return y + '-' + MM + '-' + d;
			},
			finish: function () {
				$(".sms-no").hide();
				$(".sms-yes").show();
				this.$refs.countDown.reset();
			},
			getToday:function(){
				let yy = new Date().getFullYear();
				let mm = new Date().getMonth()+1;
				if(mm<10){mm="0"+mm;}
				let dd = new Date().getDate();
				if(dd<10){dd="0"+dd;}
				return yy+"-"+mm+"-"+dd;
			},
			getFullTime:function(){
				let yy = new Date().getFullYear();
				let mm = new Date().getMonth()+1;
				if(mm<10){mm="0"+mm;}
				let dd = new Date().getDate();
				let hh = new Date().getHours();
				let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
				let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
				return yy+"-"+mm+"-"+dd+" "+hh+":"+mf+":"+ss;
			},
			getFullTimeHMS:function(){
				//let yy = new Date().getFullYear();
				//let mm = new Date().getMonth()+1;
				//if(mm<10){mm="0"+mm;}
				//let dd = new Date().getDate();
				let hh = new Date().getHours()<10 ? "0"+new Date().getHours() : new Date().getHours();
				let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
				let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
				return hh+":"+mf+":"+ss;
			},
			onSubmit: function () {
				if(JSON.parse(localStorage.getItem('LS_CITY'))==null || JSON.parse(localStorage.getItem('LS_CITY'))==''){
					this.$toast("获取不到城市定位"); return false;
				}
				if($("#temperature").val() == ''){
					this.$toast("最新体温不能为空"); return false;
				}else if((parseFloat($("#temperature").val()) != $("#temperature").val()) || parseFloat($("#temperature").val())<30 || parseFloat($("#temperature").val())>50){
					this.$toast("30 < 最新体温 <50"); return false;
				}
				if(this.vaccination == '请选择'){
					this.$toast("请选择疫苗接种"); return false;
				}
				if(this.isNonVacReason==true && this.nonVacReason == '请选择'){
					this.$toast("请选择未接种原因"); return false;
				}

				if(this.workType == '请选择'){
					this.$toast("请选择上班方式"); return false;
				}
				if(this.inQuarantine == '请选择'){
					this.$toast("请选择在隔离期"); return false;
				}else if(this.inQuarantine=="Y"){
					if(this.start_date == '请选择'){
						this.$toast("请选择开始时间"); return false;
					}
					if(this.end_date == '请选择'){
						this.$toast("请选择结束时间"); return false;
					}
					if(this.start_date > this.end_date){
						this.$toast("开始时间不能小于结束时间"); return false;
					}
				}
				if(this.arrive == '请选择'){
					this.$toast("请选择工作城市"); return false;
				}
				if(this.health == '请选择'){
					this.$toast("请选择个人情况"); return false;
				}else if(this.health == '其他不适疾病'){
					if(this.sickness == ''){
						this.$toast("个人疾病不能为空"); return false;
					}
				}
				if(this.isYardConfirmedCases == '请选择'){
					this.$toast("请选择小区有确诊"); return false;
				}
				if(this.roommateSituation == '请选择'){
					this.$toast("请选择同住人情况"); return false;
				}else if(this.roommateSituation == '其他不适疾病'){
					if(this.roommateSickness == ''){
						this.$toast("同住人疾病不能为空"); return false;
					}
				}
				//保存个人申报信息
				$("#loading").show();
				let post_data = new FormData();
				post_data.append("fUserName",JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
				post_data.append("temperature",$("#temperature").val());
				post_data.append("address",JSON.parse(localStorage.getItem('LS_ADRESS')));
				post_data.append("city",JSON.parse(localStorage.getItem('LS_CITY')));
				post_data.append("inQuarantine",this.inQuarantine);
				if(this.inQuarantine == 'Y'){
					post_data.append("startTime",this.start_date);
					post_data.append("endTime",this.end_date);
				}

				post_data.append("vaccination",this.vaccination);
				post_data.append("nonVacReason",this.nonVacReason);

				post_data.append("workType",this.workType);
				post_data.append("isArrive",this.arrive);
				post_data.append("health",this.health);
				if(this.health == '其他不适疾病'){
					post_data.append("sickness",this.sickness);
				}
				post_data.append("roommateSituation",this.roommateSituation);
				if(this.roommateSituation == '其他不适疾病'){
					post_data.append("roommateSickness",this.roommateSickness);
				}
				post_data.append("isYardConfirmedCases",this.isYardConfirmedCases);
				post_data.append("memo","");
				axios.post(this.CoreNew.OA_API_IP+"joa-business/mobile/savePersonInfo/",post_data,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
					$("#loading").hide();
					var $rs=response.data;
					if($rs.data.indexOf("success")>0){
						this.is_reports=true;
						var hour=new Date().getHours();
						var is_punch=false;
						if($(".up_temperature .show p.s-punsh").html().indexOf('未打卡') == -1 ){
							is_punch=true;
						}
						//var is_punch=$(".up_temperature .show p.s-punsh").html();
						if(this.workType=="居家办公" && is_punch==false){
							this.onConfirmPunch(0); //同时打卡
						}else if(this.workType=="居家办公" && hour>=17){
							this.onConfirmPunch(1); //同时打卡
						}else if(is_punch==false && !($(".punch-circl.active.up").is(":hidden"))){
							this.onConfirmPunch(0); //同时打卡
						}else if( hour>=17 && !($(".punch-circl.active.down").is(":hidden"))){
							this.onConfirmPunch(1); //同时打卡
						}else{
							if(is_punch==false && ($(".punch-circl.active.up").is(":hidden"))){
								var punch_up_html='<span class="title">上班时间：</span><span class="red">未打卡</span>';
								$(".up_temperature .show p.s-punsh").html(punch_up_html);
								$(".up_temperature .show p.s-loc").html('<i class="van-icon van-icon-location-o"><!----></i><span>无</span>');
							}
							this.is_close=true;
						}
						var HFMtime=this.getFullTimeHMS();//操作时间
						var up_html_show="";var down_html_show="";
						var status_html="正常";
						if ($("#temperature").val() > 37.4 && $("#temperature").val() <= 38){
							status_html = "低热";
						}else if ($("#temperature").val() > 38 && $("#temperature").val() <= 39){
							status_html = "中等度热";
						}else if ($("#temperature").val() > 39 && $("#temperature").val() <= 41){
							status_html = "高热";
						}else if ($("#temperature").val() > 41){
							status_html = "超高热";
						}
						if(is_punch==false){
							up_html_show +='<span class="title">上班体温：</span><span>'+HFMtime+'</span><span class="red">'+$("#temperature").val()+' °C</span><span class="green">'+status_html+'</span>'+this.health+'<span>('+this.workType+')</span>';
							$(".up_temperature .show p.s-tmp").html(up_html_show);
							$(".up_temperature").removeClass("hide");
							$(".down_temperature").removeClass("hide");
						}else{
							down_html_show +='<span class="title">最新体温：</span><span>'+HFMtime+'</span><span class="red">'+$("#temperature").val()+' °C</span><span class="green">'+status_html+'</span>'+this.health+'<span>('+this.workType+')</span>';
							$(".up_temperature .van-step__line").css("background-color","#969799");
							$(".down_temperature").addClass("hide");
							$(".down_temperature_ok .show p.s-tmp").html(down_html_show);
							$(".down_temperature_ok").removeClass("hide");
						}
						if(is_punch==true){
							setTimeout(()=>{
								this.is_close=false;
							},3000);
						}
					}else{
						this.$toast($rs.data.replace(/^\"|\"$/g,'')); return false;
					}
				}.bind(this)).catch(function (error) {
					$("#loading").hide();
					//alert("请求--保存个人申报信息--失败"+error);
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--保存个人申报信息--失败"+error);//记录错误
					console.log("请求--保存个人申报信息--失败"+error);
				});
			}
		}
	};
	function displayTime(){
		let hh = new Date().getHours()<10 ? "0"+new Date().getHours() : new Date().getHours();
		let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
		let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
		$(".punch-circl.active p").html(hh+":"+mf+":"+ss);
		setTimeout(()=>{
			displayTime();
		},1000);
	}
	function JStoTimeHFM(times){
		var timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
		if(parseInt(timearr[3])<10 && timearr[3].length==1){
			var timestr = "0"+timearr[3]+":" + timearr[4] + ":" + timearr[5];
		}else{
			var timestr = ""+timearr[3]+":" + timearr[4] + ":" + timearr[5];
		}
		return timestr;
	}
	//经纬度计算
	function LngLat(longitude, latitude) {
		this.longitude = longitude;
		this.latitude = latitude;
	}
	function calculateLineDistance(start, end) {
		var d1 = 0.01745329251994329;
		var d2 = start.longitude;
		var d3 = start.latitude;
		var d4 = end.longitude;
		var d5 = end.latitude;
		d2 *= d1;
		d3 *= d1;
		d4 *= d1;
		d5 *= d1;
		var d6 = Math.sin(d2);
		var d7 = Math.sin(d3);
		var d8 = Math.cos(d2);
		var d9 = Math.cos(d3);
		var d10 = Math.sin(d4);
		var d11 = Math.sin(d5);
		var d12 = Math.cos(d4);
		var d13 = Math.cos(d5);
		var arrayOfDouble1 = [];
		var arrayOfDouble2 = [];
		arrayOfDouble1.push(d9 * d8);
		arrayOfDouble1.push(d9 * d6);
		arrayOfDouble1.push(d7);
		arrayOfDouble2.push(d13 * d12);
		arrayOfDouble2.push(d13 * d10);
		arrayOfDouble2.push(d11);
		var d14 = Math.sqrt((arrayOfDouble1[0] - arrayOfDouble2[0]) * (arrayOfDouble1[0] - arrayOfDouble2[0]) +
				(arrayOfDouble1[1] - arrayOfDouble2[1]) * (arrayOfDouble1[1] - arrayOfDouble2[1]) +
				(arrayOfDouble1[2] - arrayOfDouble2[2]) * (arrayOfDouble1[2] - arrayOfDouble2[2]));
		return(Math.asin(d14 / 2.0) * 12742001.579854401);
	}
</script>
<style>
	.right-tip {
		display: inline-block;
		position: fixed;
		top:50%;
		right: 0;
		z-index: 997;
		width: 68px;
		border: 1px solid #eee;
		background: #fff;
		border-radius: 4px;
	}
	.right-tip li {
		float: left;
		width: 68px;
		text-align: center;
		cursor: pointer;
	}
	.right-tip p{
		font-size: 10px;
		padding:0px 5px 5px;
		line-height: 14px;
	}
	.right-tip li img {
		width: 68px;
		height: 68px;
		border-radius:0;
	}
</style>